// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-report-banners.has-banners{margin-bottom:20px}.mp-report-banners mp-banner.banner-hidden,.mp-report-banners mp-dropdown-banner.banner-hidden{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
